import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import ContextDataDisplay from 'Views/Onboarding/Components/ContextDataDisplay';

const styles = () => ({
  root: {},
});

// Do not delete this, please leave as an example
const SurveyContextDataDisplay = ({
  className,
  classes,
}) => {
  const contextValue = useSurveyContext();

  return (
    <ContextDataDisplay
      className={classNames(classes.root, className)}
      title={'SurveyContext'}
      contextValue={contextValue}
      amendmentMap={{
        onboardingStepCollection: ({ onboardingStepCollection }) => {
          return {
            value: onboardingStepCollection?.resources().list().map((resource) => {
              return resource.link('self').url();
            }).join(','),
          };
        },
        onboardingStepResource: ({ onboardingStepResource }) => {
          return {
            value: onboardingStepResource.link('self').url(),
          };
        },
      }}
    />
  );
};

SurveyContextDataDisplay.defaultProps = {
  className: '',
};

SurveyContextDataDisplay.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyContextDataDisplay);
